import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class ScrollService {
  
   

  constructor(@Inject(DOCUMENT) private document: Document) {
    
  }

 

  // call this to Disable
  disableScroll() {
    this.document.body.classList.add('disable-scroll')
   }

  // call this to Enable
  enableScroll() {
  this.document.body.classList.remove('disable-scroll')

   }
}
